import React from "react";
import { Layout } from "antd";
import TopicMenu from "../../components/TopicMenu/TopicMenu";
import "./Template.css";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import { useLocation } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import Client from "../Client/Client";
import Sale from "../Sale/Sale";
import Model from "../Model/Model";

function App() {
    const location = useLocation();
    const Menu = <TopicMenu />;
    return (
        <>
            <NavBar menu={Menu} />
            <Layout>
                <SideBar menu={Menu} />
                <Layout.Content className="content">
                    {location.pathname === "/dashboard" ? <Dashboard /> : ""}
                    {location.pathname === "/clients" ? <Client /> : ""}
                    {location.pathname === "/clients/:id" ? <Client /> : ""}
                    {location.pathname === "/workers" ? <Model /> : ""}
                    {location.pathname === "/money" ? <Sale /> : ""}
                    {location.pathname === "/gold" ? "" : ""}
                </Layout.Content>
            </Layout>
        </>
    );
}
export default App;
